import { render, staticRenderFns } from "./tabs-menu.vue?vue&type=template&id=5011bbac&"
import script from "./tabs-menu.vue?vue&type=script&lang=js&"
export * from "./tabs-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports